import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import Axios from "axios";
import ErrorCodes from "../../i18n/zh-cn/code";
import { Notice } from "iview";
Axios.defaults.xsrfCookieName = "pmv5-csrftoken";
Axios.defaults.xsrfHeaderName = "X-CSRFToken";
// 请求转发
Axios.interceptors.request.use(function (config) {
  if (process.env.NODE_ENV === "development") {
    var mockHeader = localStorage.proxyHost;
    if (mockHeader) {
      config.headers = config.headers || {};
      config.headers["X-Mock-Proxy"] = mockHeader;
    }
  }
  if (config.url.indexOf("/") !== 0) {
    config.url = "/pmv5/service/".concat(config.url);
  }
  // 只要服务有响应，就认为是正常的请求，响应内容是否合法根据错误码来判断
  config.validateStatus = function () {
    return true;
  };
  return config;
});

// 处理错误码
Axios.interceptors.response.use(handleCode, function (error) {
  var resp = error.response;
  // 后端正常报错
  if (resp.status === 400) {
    return handleCode(resp);
  } else {
    Notice.error({
      title: "提示",
      desc: "数据格式错误"
    });
    return Promise.reject(error);
  }
});

/**
 * 
 * @param {import("axios").AxiosResponse} resp 
 */
function handleCode(resp) {
  var code = resp.data ? resp.data.code : null;
  // 贾志浩的接口可能这样返回
  if (typeof code !== "number") {
    return resp;
  }
  if (code === 0) {
    return resp;
  } else {
    if (ErrorCodes.hasOwnProperty(code)) {
      Notice.error({
        title: "\u9519\u8BEF\u7801 ".concat(code),
        desc: resp.data.message || ErrorCodes[code]
      });
    } else {
      // 尝试读取后台可能的错误信息
      var message = resp.data.message;
      if (resp.data.errors) {
        message += ": " + readErrors(resp.data.errors);
      }
      if (!message) {
        console.error("未识别的错误码：", code);
      }
      Notice.error({
        title: "\u9519\u8BEF\u7801 ".concat(code),
        desc: message
      });
    }
    return Promise.reject(resp);
  }
}
function readErrors(errors) {
  var keys = Object.keys(errors);
  if (keys.length === 0) {
    return "";
  }
  // 仅提示第一个字段的错误信息
  var key = keys[0];
  var message = errors[key][0].message;
  return "".concat(key, ": ").concat(message);
}